import { RxCustomerAPI } from '@driftt/dapper'

export const api = {
  fetchSegments(id, orgId) {
    return RxCustomerAPI.get(`/end_users/${id}/memberships?orgId=${orgId}`)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => response)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/segment/api.js